export class Prompt{
    private static readonly url:string = "https://pia.genexus.dev/Pia/API/v1/query";

    public static async prompt(message:string, object:string, token:string):Promise<PromptResponse>{
        try{
            const response = await fetch(Prompt.url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': token,
                    'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify({
                    assistant: object.toLowerCase(),
                    prompt: message,
                    intent: "Default"
                })
            });

            const jsonResponse = await response.json();
            if (response.ok){
                return jsonResponse as PromptResponse;
            }
            else{
                console.log(JSON.stringify(jsonResponse));
                return {
                    success: false,
                } as any;
            }
        }
        catch(error){
            return {
                success: false,
                providerResponse: error+""
            } as any;
        }
    }
}

export interface PromptResponse{
    providerResponse:string;
    requestId:string;
    success:boolean;
    text:string;
    timestamp:string;
}
